import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"
import { Check, Navigation } from "lucide-react"
import React from "react"

interface ActionMessageProps {
  /** Human-readable target label, e.g. "add supplier". */
  label: string
  /** Invoked when the user confirms navigation. */
  onConfirm: () => void
  /** Once confirmed, the card stays in history as a "you went there" marker. */
  confirmed?: boolean
  className?: string
}

/**
 * Inline affordance for a cross-page agent action. Navigation is always
 * user-confirmed — clicking this is what triggers the navigate + pulse.
 * Self-start so it doesn't stretch to the full width of its flex-col parent.
 */
export const ActionMessage: React.FC<ActionMessageProps> = ({
  label,
  onConfirm,
  confirmed = false,
  className,
}) => {
  const { translate } = useTranslation()

  return (
    <Button
      type="button"
      variant={confirmed ? "outline" : "default"}
      size="sm"
      disabled={confirmed}
      onClick={onConfirm}
      className={cn("w-fit gap-1.5 self-start", className)}
    >
      {confirmed
        ? translate("AI_CHAT/ACTION_DONE", { label })
        : translate("AI_CHAT/ACTION_TAKE_ME_THERE", { label })}
      {confirmed ? (
        <Check className="h-3.5 w-3.5" />
      ) : (
        <Navigation className="h-3.5 w-3.5" />
      )}
    </Button>
  )
}
